export { disableAutofillOnFieldsAndSetAutoselectText } from './lib/disable-autofill-on-fields/disable-autofill-on-fields-and-set-autoselect-text';
